export default "__VITE_ASSET__C6pnVu33__"